import { render, staticRenderFns } from "./PageLongCorridorList.vue?vue&type=template&id=310100e7&scoped=true"
import script from "./PageLongCorridorList.vue?vue&type=script&lang=js"
export * from "./PageLongCorridorList.vue?vue&type=script&lang=js"
import style0 from "./PageLongCorridorList.vue?vue&type=style&index=0&id=310100e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310100e7",
  null
  
)

export default component.exports